import { Component, computed, input } from '@angular/core';
import { TabComponent } from '../../../components/tab/tab.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';

@Component({
  selector: 'app-classes-distribution-tab',
  imports: [APITableComponent, TabLayoutComponent],
  templateUrl: './classes-distribution-tab.component.html',
  providers: [
    { provide: TabComponent, useExisting: ClassesDistributionTabComponent },
  ],
})
export class ClassesDistributionTabComponent extends TabComponent {
  override name = this.dictionaryService.get('ClassesDistribution');

  userId = input<string>();
  endpoint = computed(() => {
    const base = '/user-customers/tables/class-distribution';
    const id = this.userId();
    return id ? `${base}/${id}` : base;
  });

  public async main(): Promise<void> {}
}
